import React from 'react';

const ShopBusinessReviewIcon: React.FC<{ size?: string }> = ({ size = '24' }) => {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			{/* Shop/Store building */}
			<path
				d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
				stroke="#FFFFFF"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			{/* Briefcase top */}
			<path
				d="M10 12H14V11C14 10.4477 13.5523 10 13 10H11C10.4477 10 10 10.4477 10 11V12Z"
				stroke="#FFFFFF"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			{/* Briefcase body */}
			<rect
				x="8"
				y="12"
				width="8"
				height="6"
				rx="1"
				stroke="#FFFFFF"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			{/* Briefcase center line */}
			<path d="M8 15H16" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
		</svg>
	);
};

export default ShopBusinessReviewIcon;
